var SkapaIconDurationEnum;
(function (SkapaIconDurationEnum) {
    SkapaIconDurationEnum["simple"] = "150ms";
    SkapaIconDurationEnum["average"] = "300ms";
    SkapaIconDurationEnum["complex"] = "600ms";
})(SkapaIconDurationEnum || (SkapaIconDurationEnum = {}));
export default SkapaIconDurationEnum;
//# sourceMappingURL=SkapaIconDurationEnum.js.map